import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, getStandaloneReport } from "./actions";
import MapContainer from "../MapContainer";
import { StyledHeader } from "../../styles";
import { cellStyle as cs } from "../gridHelper";
import { cellStyle as cstyle } from "../gridHelper";
import {
    Card,
    CardContent,
    Button,
    Typography,
    MenuItem,
    Select,
} from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";
import { selectCurrentReport } from "./selectors";
import ReactToPrint from "react-to-print";
import { gridStyle, cellStyle } from "../gridHelper";
import "../imgDiv.css";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import data from "./data";
import "./CovidReport.css";
class CovidReport extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getStandaloneReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getReport(
                path[6],
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
        this.state = {
            reportRetrieved: false,
            report: [],
            imageModal: false,
            selectedImg: false,
        };
    }
    componentDidUpdate(prevState) {
        if (prevState.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }

    renderDropDown = (key, opts) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === ""
                            ? "N/A"
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value="N/A">N/A</MenuItem>
                    {opts.map((option) => {
                        return (
                            <MenuItem value={option} key={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            );
        } else {
            return this.state.report[key] === ""
                ? "N/A"
                : this.state.report[key];
        }
    };

    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cstyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedImg: photo.photo_url,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }

    renderSigs(attachedSigs) {
        let sigRow = 2;
        let sigCell = 1;
        let ref = "";
        return attachedSigs.map((sig, i) => {
            if (sig.signature_url.includes("https:") === false) {
                ref = "data:image/png;base64," + sig.signature_url;
            }
            let sigInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            sigRow,
                            sigCell,
                            sigRow,
                            sigCell,
                            true
                        )}
                    >
                        {sig.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            sigRow,
                            sigCell + 1,
                            sigRow,
                            sigCell + 1,
                            true
                        )}
                    >
                        {sig.signature_timestamp}
                    </div>
                    {sig.signature_url.includes("https:") ? (
                        <div
                            style={cellStyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={sig.signature_url}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: sig.signature_url,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    ) : (
                        <div
                            style={cellStyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={ref}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: ref,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    )}
                </React.Fragment>
            );
            sigCell += 2;
            if (sigCell === 9) {
                sigRow += 2;
                sigCell = 1;
            }
            return sigInfo;
        });
    }

    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const cstyle = cellStyle;
        const gstyle = gridStyle;
        let color = this.props.color;
        const dp = this.renderDropDown;
        return (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                <Typography variant="h5" style={{ color: "white" }}>
                        COVID-19 : Daily Safe Start Report
                   
                
               
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                        }}
                        trigger={() => (
                            <PrintIcon
                            style={{
                                float: "right",
                                fontSize: "36px",
                                marginRight: "30px",
                                cursor:"pointer"
                            }}
                            />
                        )}
                        content={() => this.componentRef}
                    />
                     </Typography>
                    </StyledHeader>
                    <CardContent>
                    {report && (
                        <div ref={(el) => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}
                            <div style={{ width: "100%" }}>
                                <div style={{ width: "60%", float: "left" }}>
                                    <div style={gstyle(7, 13, null, color)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Information</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Name:&nbsp;</b>
                                            {report.user_name
                                                ? report.user_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13, true)}>
                                            <b>Email:&nbsp;</b>
                                            {report.user_email
                                                ? report.user_email
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Job Name:&nbsp;</b>
                                            {report.job_name
                                                ? report.job_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13, true)}>
                                            <b>Date:&nbsp;</b>
                                            {report.timestamp
                                                ? report.timestamp
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 13)}>
                                            <b>Job Address:&nbsp;</b>
                                            {report.address
                                                ? report.address
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 13)}>
                                            <b>Work Summary:&nbsp; </b>
                                            {report.work_summary
                                                ? report.work_summary
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 13)}>
                                            <b>COVID Compliance Officer: </b>
                                            {report.covid_compliance_officer
                                                ? report.covid_compliance_officer
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 7)}>
                                            <b>Longitude:&nbsp;</b>
                                            {report.location_lon
                                                ? report.location_lon
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(7, 7, 7, 13, true)}>
                                            <b>Latitude:&nbsp;</b>
                                            {report.location_lat
                                                ? report.location_lat
                                                : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "38%",
                                        float: "left",
                                        marginLeft: "2%",
                                    }}
                                >
                                    <MapContainer
                                        lat={+report.location_lat}
                                        long={+report.location_lon}
                                        style={{ width: "80%" }}
                                    />
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div style={gstyle(4, 4)}>
                                    <div
                                        style={cstyle(1, 1, 1, 4, false, true)}
                                    >
                                        <b>Risk Assessment</b>
                                    </div>
                                    {report.ra_q1 !== "N/A" && (
                                        <React.Fragment>
                                            <div style={cstyle(2, 1, 2, 1)}>
                                                <b>Social Distancing</b>
                                            </div>
                                            <div style={cstyle(2, 2, 2, 4)}>
                                                <b>
                                                    Can the task be completed
                                                    following the 2m social
                                                    distancing guidelines?
                                                </b>
                                            </div>
                                            <div style={cstyle(2, 4, 2, 4)}>
                                                <b>
                                                    {report.ra_q1 === "Yes" ? (
                                                        <CheckIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "green",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : report.ra_q1 ===
                                                      "No" ? (
                                                        <ClearIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "red",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </b>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {report.ra_q2 !== "N/A" && (
                                        <React.Fragment>
                                            <div style={cstyle(3, 1, 3, 1)}>
                                                <b>
                                                    Transmission Consideration
                                                </b>
                                            </div>
                                            <div style={cstyle(3, 2, 3, 4)}>
                                                <div>
                                                    <b>
                                                        {" "}
                                                        Can transmission points
                                                        be eliminated?
                                                    </b>
                                                </div>
                                            </div>
                                            <div style={cstyle(3, 4, 3, 4)}>
                                                <b>
                                                    {report.ra_q2 === "Yes" ? (
                                                        <CheckIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "green",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : report.ra_q2 ===
                                                      "No" ? (
                                                        <ClearIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "red",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </b>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {report.ra_q3 !== "N/A" && (
                                        <React.Fragment>
                                            <div style={cstyle(4, 1, 4, 1)}>
                                                <b>
                                                    Transmission Consideration
                                                </b>
                                            </div>
                                            <div style={cstyle(4, 2, 4, 4)}>
                                                <div>
                                                    <b>
                                                        Can transmission points
                                                        be cleaned before and
                                                        after use?
                                                    </b>
                                                </div>
                                            </div>
                                            <div style={cstyle(4, 4, 4, 4)}>
                                                <b>
                                                    {report.ra_q3 === "Yes" ? (
                                                        <CheckIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "green",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : report.ra_q3 ===
                                                      "No" ? (
                                                        <ClearIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "red",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </b>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {report.ra_q4 !== "N/A" && (
                                        <React.Fragment>
                                            <div style={cstyle(5, 1, 5, 1)}>
                                                <b>Social Distancing</b>
                                            </div>
                                            <div style={cstyle(5, 2, 5, 4)}>
                                                <div>
                                                    <b>
                                                        Is another work method
                                                        or sequence possible?
                                                    </b>
                                                </div>
                                            </div>
                                            <div style={cstyle(5, 4, 5, 4)}>
                                                <b>
                                                    {report.ra_q4 === "Yes" ? (
                                                        <CheckIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "green",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : report.ra_q4 ===
                                                      "No" ? (
                                                        <ClearIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "red",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </b>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {report.ra_q5 !== "N/A" && (
                                        <React.Fragment>
                                            <div style={cstyle(6, 1, 6, 1)}>
                                                <b>
                                                    Transmission Consideration
                                                </b>
                                            </div>
                                            <div style={cstyle(6, 2, 6, 4)}>
                                                <div>
                                                    <b>
                                                        Can transmission points
                                                        be eliminated?
                                                    </b>
                                                </div>
                                            </div>
                                            <div style={cstyle(6, 4, 6, 4)}>
                                                <b>
                                                    {report.ra_q5 === "Yes" ? (
                                                        <CheckIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "green",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : report.ra_q5 ===
                                                      "No" ? (
                                                        <ClearIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "red",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </b>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {report.ra_q6 !== "N/A" && (
                                        <React.Fragment>
                                            <div style={cstyle(7, 1, 7, 1)}>
                                                <b>
                                                    {" "}
                                                    Transmission Consideration
                                                </b>
                                            </div>
                                            <div style={cstyle(7, 2, 7, 4)}>
                                                <div>
                                                    <b>
                                                        {" "}
                                                        Are other preventitive
                                                        measures possible?
                                                    </b>
                                                </div>
                                            </div>
                                            <div style={cstyle(7, 4, 7, 4)}>
                                                <b>
                                                    {report.ra_q6 === "Yes" ? (
                                                        <CheckIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "green",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : report.ra_q6 ===
                                                      "No" ? (
                                                        <ClearIcon
                                                            style={{
                                                                backgroundColor:
                                                                    "red",
                                                                color: "white",
                                                            }}
                                                        />
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </b>
                                            </div>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>

                            <div style={{ width: "100%", clear: "both" }}>
                                {Object.keys(data).map((category) => {
                                    return (
                                        <div>
                                            <div
                                                style={{
                                                    ...cs(
                                                        1,
                                                        1,
                                                        1,
                                                        5,
                                                        false,
                                                        true
                                                    ),

                                                    position: "relative",
                                                }}
                                            >
                                                <b>{category}</b>
                                            </div>

                                            <ul
                                                className="customList"
                                                style={{
                                                    padding: "0",
                                                    marginTop: "0",
                                                    marginBottom: "0rem",
                                                }}
                                            >
                                                {data[category].map(
                                                    (control) => {
                                                        return (
                                                            <li
                                                                className={dp(
                                                                    control.key,
                                                                    [
                                                                        "No",
                                                                        "Yes",
                                                                    ]
                                                                )}
                                                            >
                                                                <div>
                                                                    <img
                                                                        alt={
                                                                            control.key
                                                                        }
                                                                        src={
                                                                            control.icon
                                                                        }
                                                                        style={{
                                                                            height:
                                                                                "100px",
                                                                            margin:
                                                                                "auto",
                                                                            display:
                                                                                "block",
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div
                                                                    className={
                                                                        dp(
                                                                            control.key,
                                                                            [
                                                                                "No",
                                                                                "Yes",
                                                                            ]
                                                                        ) +
                                                                        " text-center"
                                                                    }
                                                                ></div>
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                        </div>
                                    );
                                })}
                                <br />
                                <br />
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Photos</b>
                                    </div>
                                    {report.attached_photos &&
                                        this.renderPhotos(
                                            report.attached_photos
                                        )}
                                </div>
                                <br />
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Signatures</b>
                                    </div>
                                    {report.attached_signatures &&
                                        this.renderSigs(
                                            report.attached_signatures
                                        )}
                                </div>
                                <br />
                                <br />
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Thumbs Up</b>
                                    </div>
                                    {report.attached_thumbs_up_photos &&
                                        this.renderPhotos(
                                            report.attached_thumbs_up_photos
                                        )}
                                </div>

                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Last Induction Location Details</b>
                                    </div>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Last Induction Location Details</b>
                                    </div>

                                    <div style={cstyle(2, 1, 2, 1, true)}>
                                        <b>Latitude</b> &nbsp;{" "}
                                        {report.last_induction_location_lat}
                                    </div>

                                    <div style={cstyle(2, 2, 2, 2, true)}>
                                        <b>Longitude</b> &nbsp;{" "}
                                        {report.last_induction_location_lon}
                                    </div>

                                    <div style={cstyle(3, 1, 3, 3, true)}>
                                        <div
                                            style={{
                                                width: "30%",
                                                float: "left",
                                                marginLeft: "35%",
                                                height: "300px",
                                            }}
                                        >
                                            <MapContainer
                                                lat={
                                                    +report.last_induction_location_lat
                                                }
                                                long={
                                                    +report.last_induction_location_lon
                                                }
                                                style={{ width: "80%" }}
                                            />
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Details</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        this.state.selectedImg
                                            ? this.state.selectedImg
                                            : noImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: "",
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    (store) => {
        return {
            report: selectCurrentReport(store),
        };
    },
    { getReport, getStandaloneReport }
)(CovidReport);
